import * as React from 'react';
import { GoogleMap, KmlLayer, withGoogleMap, withScriptjs } from "react-google-maps";
import HeatmapLayer from 'react-google-maps/lib/components/visualization/HeatmapLayer';
import * as MapActionCreators from "../../actions/map.actions";
import * as Configuration from '../../configuration';
import { googleMapTypeIdTypes } from '../../configuration/ICustomConfiguration';


import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer";
import { compose, withState, withHandlers, withStateHandlers } from "recompose";
import { LatLong } from '../../reducers/map.reducer';


type MapProps = {
    lat: number;
    lng: number;
    
    defaultZoom: number;
    googleMapURL: string;
    gridSize: number;
    height: React.ReactText;
    interactive: boolean;
    layers: any;
    mapType: string;
    mapTypeId: googleMapTypeIdTypes;
    markers: JSX.Element[];
    newMarker?: JSX.Element;
    zoomInOnClick: boolean;
};

type MapActions = {
    onMapClicked?: Function,
    toggleNewMarkerPopup: typeof MapActionCreators.toggleNewMarkerPopupRequest
    cacheMapSettings?: typeof MapActionCreators.cacheMapSettingsAction;
};

type MapAllProps = MapProps & MapActions;

type ScanMapProps = {
    /* required by library */
    lat: number;
    lng: number;
    containerElement: any;
    loadingElement: any;
    googleMapURL: string;
    mapElement: any;

    defaultZoom: number;
    gridSize: number;
    interactive: boolean;
    layers: any[];
    mapType: string;
    mapTypeId: googleMapTypeIdTypes;
    markers: JSX.Element[];
    newMarker?: JSX.Element;
    openMarkers: number[];
    zoom: any;
    zoomInOnClick: boolean;
};

type ScanMapActions = {
    onClickHandler: Function;

    onClick: Function;
    onDragEnd: Function;
    onMapMounted: Function;
    onZoomChanged: Function;

    cacheMapSettings: any;
};

type ScanMapAllProps = ScanMapProps & ScanMapActions;

const ScanMap: (props: ScanMapAllProps) => any = compose(
    withStateHandlers(() => ({
        isOpen: false
    })),
    withState('zoom', 'changeZoom', props => {
        return props.defaultZoom
    }),
    withHandlers(() => {
        const refs = {
            map: undefined,
        }

        return {
            onMapMounted: () => ref => {
                refs.map = ref;
            },
            onClickHandler: props => (obj) => {
                if (props.zoomInOnClick) {
                    const zoomLevel = 12;

                    if(refs.map.getZoom() < zoomLevel) {
                        var lat = obj.latLng.lat();
                        var lng = obj.latLng.lng();

                        var bounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(lat -0.1, lng - 0.1),
                            new google.maps.LatLng(lat + 0.1, lng + 0.1)
                        );

                        // we use fitBounds instead of just setting zoom level as it 
                        // lets us place the point in the centre of the view
                        refs.map.fitBounds(bounds);
                    }
                }

                props.onClick(obj);
            },
            onZoomChanged: props => () => {
            //onZoomChanged: ({ changeZoom }) => (props) => {

                props.changeZoom(refs.map.getZoom());

                if(props.cacheMapSettings) {

                    const latLng = refs.map.getCenter();
                    const loc: LatLong = { latitude: latLng.lat(), longitude: latLng.lng() };
                    props.cacheMapSettings(refs.map.getZoom(), loc);
                }

            }
        }
    }),
    withScriptjs,
    withGoogleMap
)((props: ScanMapAllProps) => {

    var { markers, newMarker } = props;

    var clusterStyles = [
        {
            textColor: 'black',
            url: require("../../assets/img/markerClusterer/default/m1.png"),
            height: 30,
            width: 30
        },
        {
            textColor: 'black',
            url: require("../../assets/img/markerClusterer/default/m2.png"),
            height: 40,
            width: 40
        },
        {
            textColor: 'black',
            url: require("../../assets/img/markerClusterer/default/m3.png"),
            height: 66,
            width: 65
        },
        {
            textColor: 'black',
            url: require("../../assets/img/markerClusterer/default/m4.png"),
            height: 78,
            width: 77
        },
        {
            textColor: 'black',
            url: require("../../assets/img/markerClusterer/default/m5.png"),
            height: 90,
            width: 89
        }
    ];

    if (props.mapType == "clustered") {
        markers = [<MarkerClusterer
            averageCenter
            enableRetinaIcons
            gridSize={props.gridSize}
            key={`markercluster`}
            styles={clusterStyles}
        >
            {markers}
        </MarkerClusterer>];
    } else if (props.mapType == "heat") {
        var mapData = props.markers ? props.markers.map((m, i) => {
            if (m && m.props && m.props.position)
            return {
                location: new google.maps.LatLng(
                    m.props.position.lat,
                    m.props.position.long
                ),
                weight: 1
            }
        }) : undefined;
        markers = [<HeatmapLayer
            data={mapData}
            key={`heatmap`}
            options={{
                radius: 30,
                gradient: [
                    "rgba(249,190,56, 0)",
                    "rgba(249,190,56, 1)",
                    "rgba(246,173,56, 1)",
                    "rgba(244,155,56, 1)",
                    "rgba(241,138,55, 1)",
                    "rgba(238,121,55, 1)",
                    "rgba(235,103,55, 1)",
                    "rgba(233,86,55, 1)",
                    "rgba(230,68,54, 1)",
                    "rgba(227,51,54, 1)"
                ],
                opacity: 0.95
            }}
        />];
    }

    var layers = props.layers ? props.layers.map((m, i) =>
        <KmlLayer key={i}
            url={m.kmlFileName}
            options={{ preserveViewport: true, clickable: m.clickable ? m.clickable : false }}
        />) : undefined;


    return <GoogleMap
        defaultCenter={{ lat: props.lat, lng: props.lng }}
        defaultOptions={{
            streetViewControl: false,
            scaleControl: props.interactive,
            mapTypeControl: true,
            panControl: props.interactive,
            zoomControl: true,
            mapTypeId: props.mapTypeId,
            fullscreenControl: props.interactive,
            rotateControl: props.interactive,
            rotateControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_RIGHT
            },
            styles: Configuration.custom.mapStyles
        }}
        defaultZoom={props.defaultZoom}
        tilt={45}

        onClick={props.onClickHandler.bind(this)}
        onDragEnd={props.onDragEnd.bind(this)}
        onZoomChanged={props.onZoomChanged.bind(this)}
        ref={props.onMapMounted}
        zoom={props.zoom}
    >
        {newMarker}
        {markers}
        {layers}
    </GoogleMap>
});

export class Map extends React.Component<MapAllProps, any> {
    constructor(props, context) {
        super(props, context);
        this.onMapMounted = this.onMapMounted.bind(this);
        this.zoomHasChanged = this.zoomHasChanged.bind(this);
        this.dragEnded = this.dragEnded.bind(this);
        this.onMapClicked = this.onMapClicked.bind(this);
        this.updateMapChanged = this.updateMapChanged.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {

    }

    onMapClicked(obj) {
        var lat = obj.latLng.lat();
        var lng = obj.latLng.lng();

        if (this.props.toggleNewMarkerPopup) {
            this.props.toggleNewMarkerPopup(lat, lng);
        }
        if (this.props.onMapClicked) {
            this.props.onMapClicked(lat, lng);
        }
    }

    updateMapChanged() {
    }

    onMapMounted(mapRef) {
    }

    dragEnded() {
        this.updateMapChanged();
    }

    zoomHasChanged() {
        this.updateMapChanged();
    }

    render() {
        return (<ScanMap
            lat={this.props.lat}
            lng={this.props.lng}
            containerElement={<div style={{ height: this.props.height }} />}
            googleMapURL={this.props.googleMapURL}
            loadingElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}

            defaultZoom={this.props.defaultZoom}
            gridSize={this.props.gridSize}
            interactive={this.props.interactive}
            layers={this.props.layers}
            mapType={this.props.mapType}
            mapTypeId={this.props.mapTypeId}
            markers={this.props.markers}
            newMarker={this.props.newMarker}
            
            onClick={this.onMapClicked}
            onDragEnd={this.dragEnded}
            onMapMounted={this.onMapMounted}
            onZoomChanged={this.zoomHasChanged}

            cacheMapSettings={this.props.cacheMapSettings}

            zoomInOnClick={this.props.zoomInOnClick}
            openMarkers={undefined}
            key="map"
            onClickHandler={undefined}
            zoom={undefined}
        />
        );
    }
}

